
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/um/fyrirtaekid/starfsumsokn",
      function () {
        return require("private-next-pages/um/fyrirtaekid/starfsumsokn.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/um/fyrirtaekid/starfsumsokn"])
      });
    }
  